import Uploader from "../../../../../../../common/inputs/Uploader.jsx";
import {Input, Textarea} from "../../../../../../../common/inputs/index.js";
import {useParams} from "react-router-dom";
import SelectDictSearch from "../../../../../../../common/inputs/SelectDictSearch.jsx";
import {MAIN_REJESTR_API_SHORT} from "../../../../../../../utils/consts.js";
import {HeaderTitle} from "../../../../../../../common/HeaderTitle.jsx";
import {useSelector} from "react-redux";

export const Zalaczniki = () => {

    const userType = useSelector(store => store?.user?.role)
    const userPath = userType === 'oper' ? '/oper' : ""
    const {id} = useParams()

    return <>
        <HeaderTitle noHr size={'fs-3'} title={'Załączniki'}/>

        <Uploader
            // debug
            uploadUrl={`${userPath}/${MAIN_REJESTR_API_SHORT}/pliki/dodaj`}
            downloadUrl={`${userPath}/${MAIN_REJESTR_API_SHORT}/pliki/download`}
            uploadedUrl={`${userPath}/${MAIN_REJESTR_API_SHORT}/pliki/${id}`}
            configUrl="config/g/file"
            modalDeleteButtonText={'Usuń plik'}
            modalBodyText={'Czy na pewno chcesz usunąć załącznik z formularza elementu?'}
            deleteUrl={`${userPath}/${MAIN_REJESTR_API_SHORT}/pliki/${id}`}
            editUrl={`${userPath}/${MAIN_REJESTR_API_SHORT}/pliki/modyfikuj`}
            fileConst={{id: +id}}
            headers={<>
                <th>Opis</th>
                <th width={'15%'}>Rodzaj</th>
            </>}
            rowSelected={(file, set) => {
                return <>
                    <td>
                        <Input value={file.opis || ''}
                               onChange={e => set('opis', e.target.value)}/>
                    </td>
                    <td>

                        <SelectDictSearch
                            dictName={'typ_pliku'}
                            endpoint={`${userPath}/slowniki`}
                            value={file.slownik_typ_pliku_id || ''}
                            onChange={e => set('slownik_typ_pliku_id', e?.value)}
                        />
                    </td>

                </>
            }}
            rowUploaded={(file) => <>
                <td>{file.opis}</td>
                <td>{file.typ_pliku_nazwa}</td>
            </>

            }

            editForm={(file, set) => <>
                <div className={'mt-2'}>
                    <Input
                        label={'Nazwa'} value={file.nazwa || ''}
                        onChange={e => set('nazwa', e.target.value)}/></div>

                <div className={'mt-2'}>
                    <SelectDictSearch
                        label={'Rodzaj'}
                        dictName={'typ_pliku'}
                        endpoint={`${userPath}/slowniki`}
                        value={file.slownik_typ_pliku_id || ''}
                        onChange={e => set('slownik_typ_pliku_id', e?.value)}
                    />
                </div>
                <div className={'mt-2'}>
                    <Textarea
                        rows={4} label={'Opis'} value={file.opis || ''}
                        onChange={e => set('opis', e.target.value)}/></div>

            </>
            }
        />

    </>
};

Zalaczniki.propTypes = {};